var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMetricWidget = function SvgMetricWidget(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 72,
    viewBox: "0 0 194 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100.593,
    y: 9.65433,
    width: 93.4074,
    height: 9.58025,
    rx: 4.79012,
    fill: "#E4E8EE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100.593,
    y: 28.8148,
    width: 47.9012,
    height: 4.79012,
    rx: 2.39506,
    fill: "#E4E8EE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100.593,
    y: 57.5555,
    width: 23.9506,
    height: 4.79012,
    rx: 2.39506,
    fill: "#BABDC1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 0.0740967,
    width: 71.8519,
    height: 71.8519,
    rx: 9.58025,
    fill: "#A2A5AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7409 34.2037C31.7946 34.2037 34.1298 31.8685 34.1298 28.8148C34.1298 25.7611 31.7946 23.4259 28.7409 23.4259C25.6872 23.4259 23.3521 25.7611 23.3521 28.8148C23.3521 31.8685 25.6872 34.2037 28.7409 34.2037ZM28.7409 27.0185C29.8187 27.0185 30.5372 27.737 30.5372 28.8148C30.5372 29.8926 29.8187 30.6111 28.7409 30.6111C27.6632 30.6111 26.9446 29.8926 26.9446 28.8148C26.9446 27.737 27.6632 27.0185 28.7409 27.0185Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1113 37.7963C40.0576 37.7963 37.7224 40.1315 37.7224 43.1852C37.7224 46.2389 40.0576 48.5741 43.1113 48.5741C46.165 48.5741 48.5002 46.2389 48.5002 43.1852C48.5002 40.1315 46.165 37.7963 43.1113 37.7963ZM43.1113 44.9815C42.0335 44.9815 41.315 44.263 41.315 43.1852C41.315 42.1074 42.0335 41.3889 43.1113 41.3889C44.1891 41.3889 44.9076 42.1074 44.9076 43.1852C44.9076 44.263 44.1891 44.9815 43.1113 44.9815Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7039 23.4259H37.7224V27.0185H42.3928L23.8909 45.5204C23.1724 46.2389 23.1724 47.3167 23.8909 48.0352C24.2502 48.3945 24.6095 48.5741 25.1483 48.5741C25.6872 48.5741 26.0465 48.3945 26.4058 48.0352L44.9076 29.5333V34.2037H48.5002V25.2222C48.5002 24.1445 47.7817 23.4259 46.7039 23.4259Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMetricWidget);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "metric-widget.d74b576024929cee2d2771c988c537a7.svg";